export const NODE_ENV = process.env.NODE_ENV ?? 'development';
export const CLOUD_CONVERT_API_KEY = process.env.CLOUD_CONVERT_API_KEY ?? '';
